import React from "react";
import { useTranslation } from "react-i18next";
import Text, { TextVariant } from "@/components/ui/text";
import ConfidenceLevelIcon from "@/components/controls/ConfidenceLevelIcon";
import { CsmRenewalConfidenceLevel } from "@/pages/deals/types";
import { getEnumTKey } from "@/utils/strings";

interface Props {
  value: CsmRenewalConfidenceLevel;
  valueVariant: TextVariant;
}

// Read-only: the value is AI-derived, so there is nothing for the user to set.
const AiRenewalProbabilityKPI: React.FC<Props> = ({ value, valueVariant }) => {
  const { t } = useTranslation();

  return (
    <>
      <ConfidenceLevelIcon value={value} />
      <Text as="span" variant={valueVariant}>
        {t(getEnumTKey("deals", "levels", CsmRenewalConfidenceLevel, value))}
      </Text>
    </>
  );
};

export default AiRenewalProbabilityKPI;
